import { render, staticRenderFns } from "./image_preview.vue?vue&type=template&id=6a81fe8c&scoped=true&"
import script from "./image_preview.vue?vue&type=script&lang=js&"
export * from "./image_preview.vue?vue&type=script&lang=js&"
import style0 from "./image_preview.vue?vue&type=style&index=0&id=6a81fe8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a81fe8c",
  null
  
)

export default component.exports